"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceWithParams = void 0;
function replaceWithParams(path, params) {
    return path
        .split('/')
        .map(segment => {
        if (segment.startsWith(':')) {
            const param = segment.slice(1);
            return params[param] || segment;
        }
    })
        .join('/');
}
exports.replaceWithParams = replaceWithParams;
//# sourceMappingURL=replaceWithParams.js.map